import React from 'react'
import { useNavigate, Link } from 'react-router-dom'
import './LandingPage.css'
import { useCurrentBasho } from '../hooks/useCurrentBasho'
import { getToken, clearAuth } from '../auth'

export default function LandingPage() {
  const navigate = useNavigate()
  const isAdmin = localStorage.getItem('isAdmin') === 'true'
  const username = localStorage.getItem('username')
  const isLoggedIn = !!getToken()
  const { basho, day, status, loading: bashoLoading, daysUntil, startDate } = useCurrentBasho()

  const bashoDisplayName = (bashoId) => {
    if (!bashoId) return 'The next basho'
    const month = parseInt(bashoId.slice(4, 6))
    const names = { 1: 'Hatsu', 3: 'Haru', 5: 'Natsu', 7: 'Nagoya', 9: 'Aki', 11: 'Kyushu' }
    return (names[month] || 'The next') + ' basho'
  }

  const formatStartDate = (sd) => {
    if (!sd) return null
    const d = new Date(sd)
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', timeZone: 'UTC' })
  }

  const handleLogout = () => {
    clearAuth()
    navigate('/')
  }

  return (
    <div className="landing">
      <div className="paper-texture"></div>
      <div className="stamp-band"></div>
      <div className="border-frame"></div>
      <div className="corner corner-tl"></div>
      <div className="corner corner-tr"></div>
      <div className="corner corner-bl"></div>
      <div className="corner corner-br"></div>
      <div className="dohyo-ring"></div>
      <div className="dohyo-ring-inner"></div>
      <div className="seal"><div className="seal-text">相撲<br />番付</div></div>
      <div className="side-kanji">大相撲本場所</div>
      {isLoggedIn && (
        <div className="top-right-links">
          <Link to="/profile" className="top-right-link">Profile</Link>
          <span className="top-right-sep">·</span>
          <button className="top-right-link top-right-btn" onClick={handleLogout}>Log out</button>
        </div>
      )}

      <svg className="rikishi-svg" viewBox="0 0 300 560" xmlns="http://www.w3.org/2000/svg" fill="#1A0A00">
        <ellipse cx="148" cy="30" rx="10" ry="7"/>
        <rect x="143" y="30" width="10" height="16" rx="3"/>
        <ellipse cx="148" cy="68" rx="36" ry="38"/>
        <path d="M128 102 Q118 112 116 124 L180 124 Q178 112 168 102Z"/>
        <path d="M88 124 Q62 148 54 200 Q48 240 58 272 Q72 300 110 314 Q128 320 148 320 Q168 320 186 314 Q224 300 238 272 Q248 240 242 200 Q234 148 208 124Z"/>
        <path d="M72 248 Q60 258 58 272 L238 272 Q236 258 224 248Z"/>
        <path d="M128 272 Q118 286 116 302 Q122 312 148 314 Q174 312 180 302 Q178 286 168 272Z"/>
        <path d="M88 140 Q72 128 52 112 Q36 98 22 88 Q10 82 8 94 Q6 108 18 118 Q36 132 58 148 Q76 162 96 172 Q104 156 100 140Z"/>
        <ellipse cx="12" cy="108" rx="14" ry="11" transform="rotate(-30 12 108)"/>
        <path d="M208 148 Q228 160 252 180 Q268 194 278 210 Q286 224 276 232 Q264 238 252 226 Q234 208 212 188 Q196 172 188 158Z"/>
        <ellipse cx="278" cy="224" rx="14" ry="11" transform="rotate(20 278 224)"/>
        <path d="M106 314 Q88 330 72 354 Q56 378 48 408 Q38 444 46 466 Q56 482 74 480 Q90 476 96 458 Q104 434 112 404 Q122 370 128 340 Q122 324 114 316Z"/>
        <path d="M40 468 Q30 478 32 490 Q38 500 68 498 Q92 496 98 484 Q100 472 88 466Z"/>
        <path d="M188 316 Q200 332 210 358 Q222 388 228 420 Q234 452 228 470 Q220 486 202 486 Q184 484 178 466 Q172 444 172 414 Q172 378 176 346 Q178 328 184 318Z"/>
        <path d="M168 468 Q158 478 162 492 Q170 502 202 500 Q226 496 232 482 Q234 470 222 464Z"/>
        <path d="M96 230 Q108 244 148 248 Q188 244 200 230 Q188 238 148 240 Q108 238 96 230Z" fill="#0A0400" opacity="0.6"/>
        <rect x="60" y="400" width="28" height="44" rx="8" opacity="0.7"/>
        <rect x="200" y="400" width="28" height="44" rx="8" opacity="0.7"/>
      </svg>

      <div className="wave-band"></div>
      <div className="wave-band-2"></div>

      <div className="content-area">
        <div className="jp-title">大相撲 · Hon Basho</div>
        <div className="main-title">Sumo<br /><span className="title-accent">Pick'em</span></div>
        <div className="divider-line"></div>
        <div className="tagline">Pick the winner of every bout</div>
        <div className="btn-row">
          {isLoggedIn ? (
            <>
              <button className="btn-primary" onClick={() => navigate(`/picks/${basho}/${day}`)} disabled={bashoLoading}>Go to Picks</button>
              <button className="btn-secondary" onClick={() => navigate(`/leaderboard/${basho}/${day}`)} disabled={bashoLoading}>Leaderboard</button>
            </>
          ) : (
            <>
              <button className="btn-primary" onClick={() => navigate('/signup')}>Join the basho</button>
              <button className="btn-secondary" onClick={() => navigate('/login')}>Sign in</button>
            </>
          )}
        </div>
        <div className="hon-basho">
          <div className="basho-tag"><div className="basho-dot"></div>Hatsu · Jan</div>
          <div className="basho-tag"><div className="basho-dot"></div>Haru · Mar</div>
          <div className="basho-tag"><div className="basho-dot"></div>Natsu · May</div>
          <div className="basho-tag"><div className="basho-dot"></div>Nagoya · Jul</div>
          <div className="basho-tag"><div className="basho-dot"></div>Aki · Sep</div>
          <div className="basho-tag"><div className="basho-dot"></div>Kyushu · Nov</div>
        </div>

        {!bashoLoading && status !== 'active' && (
          <div className="how-it-works">
            {status === 'upcoming' && daysUntil != null && (
              <div className="basho-countdown">
                <span className="countdown-name">{bashoDisplayName(basho)}</span>
                {' '}begins in{' '}
                <span className="countdown-num">{daysUntil}</span>
                {' '}{daysUntil === 1 ? 'day' : 'days'}
                {startDate && <span className="countdown-date"> · {formatStartDate(startDate)}</span>}
              </div>
            )}
            <div className="how-divider"><span>How it works</span></div>
            <div className="how-steps">
              <div className="how-step">
                <div className="step-num">一</div>
                <div className="step-body">
                  <div className="step-title">Pick daily</div>
                  <div className="step-desc">Before bouts begin each day, choose your winner for every match on the card. Picks lock when the matches start.</div>
                </div>
              </div>
              <div className="how-step">
                <div className="step-num">二</div>
                <div className="step-body">
                  <div className="step-title">Score points</div>
                  <div className="step-desc">Earn one point for each correct pick. Picks lock when the matches start, so get yours in before bout time.</div>
                </div>
              </div>
              <div className="how-step">
                <div className="step-num">三</div>
                <div className="step-body">
                  <div className="step-title">Win the basho</div>
                  <div className="step-desc">Most correct picks after all 15 days claims the 優勝 (yūshō). Six tournaments a year to compete.</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="footer-links">
        <a className="footer-link" href="https://www.sumo.or.jp/En/" target="_blank" rel="noreferrer">Japan Sumo Association</a>
        <a className="footer-link" href="https://www.sumostats.com" target="_blank" rel="noreferrer">SumoStats</a>
        {isAdmin && <Link to="/admin" className="footer-link">Admin</Link>}
      </div>
    </div>
  )
}
